import $http from './http'
import config from './config'

export default {
    name: 'insurancepolicy',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getInsuranceProductList(data) {
        return $http.post(this.getUrl(`/InsuranceProduct/List`), data);
    },
    getInsuranceProductDetails(ProductID) {
        return $http.get(this.getUrl(`/InsuranceProduct/Details/${ProductID}`));
    },
    getInsuranceProductDelete(ProductID) {
        return $http.get(this.getUrl(`/InsuranceProduct/Delete/${ProductID}`));
    },
    saveInsuranceProduct(data) {
        return $http.post(this.getUrl(`/InsuranceProduct/SaveInsuranceProduct`), data);
    },
    getInsuranceThrowList(data) {
        return $http.post(this.getUrl(`/PolicyThrow/List`), data);
    },
    getInsuranceThrowDetails(ThrowID) {
        return $http.get(this.getUrl(`/PolicyThrow/Details/${ThrowID}`));
    },
    getInsuranceThrowDelete(ThrowID) {
        return $http.get(this.getUrl(`/PolicyThrow/Delete/${ThrowID}`));
    },
    saveInsuranceThrow(data) {
        return $http.post(this.getUrl(`/PolicyThrow/SaveInsuranceThrow`), data);
    },
    //下单保险匹配
    getInsuranceMatching (data){
        return $http.post(this.getUrl(`/PolicyThrow/InsuranceMatching`),data);
    },
    getProductInfo(data){
        return $http.post(this.getUrl('/PolicyInfo/productInfo'),data,{failTips:false});
    },
    // 需求单保险
    getPolicyInfo(data){
        return $http.post(this.getUrl('/PolicyInfo/GetPolicyInfo'),data);
    },

    getPolicyInfoList(data){
                return $http.post(this.getUrl('/PolicyInfo/List'),data)
    },
    getPolicyInfoDetail(id){
        return $http.get(this.getUrl(`/PolicyInfo/Details?id=${id}`))
    },
    getPolicyInfoDelete(id){
        return $http.get(this.getUrl(`/PolicyInfo/Delete?id=${id}`))
    },
    savePolicyInfo(data){
        return $http.post(this.getUrl('/PolicyInfo/Save'),data)
    },
    getProductInfoList(data){return $http.post(this.getUrl('/ProductInfo/List'),data)
    },
    getProductInfoDetail(id){
        return $http.post(this.getUrl(`/ProductInfo/Details?id=${id}`))
    },
    getProductInfoDelete(id){
        return $http.post(this.getUrl(`/ProductInfo/Delete?id=${id}`))
    },
    saveProductInfo(data){
        return $http.post(this.getUrl('/ProductInfo/Save'),data)
    },
		getThrowInfoList(data){
				return $http.post(this.getUrl('/ThrowInfo/List'),data)
		},
    getThrowInfoDetails(id){
        return $http.post(this.getUrl(`/ThrowInfo/Details?id=${id}`))
    },
    getThrowInfoDelete(id){
        return $http.post(this.getUrl(`/ThrowInfo/Delete?id=${id}`))
    },
    saveThrowInfo(data){
        return $http.post(this.getUrl('/ThrowInfo/Save'),data)
    },
		//robot
		getRobotList(data){
			return $http.post(this.getUrl('/robotinfo/list'),data)
		},
		saveRobotInfo(data){
				return $http.post(this.getUrl('/robotinfo/save'),data)
		},
		getRobotInfo(id){
				return $http.get(this.getUrl('/robotinfo/details?id='+id));
		},
		deleteRobotInfo(id){
				return $http.get(this.getUrl('/robotinfo/delete?id='+id))
		},

}



// WEBPACK FOOTER //
// ./src/apis/insurancePolicyApis.js